import styled from '@emotion/styled';

export const FreeSamplesContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LabelContainer = styled.div`
  font-size: ${(props) => props.theme.FONTS.FONT_SIZE_SMALLER};
  font-weight: ${(props) => props.theme.FONTS.FONT_WEIGHT_SEMI_BOLD};
`;
